import { Box, Typography } from '@mui/material';
import { PriorityIcon, SeverityIcon, Tooltip } from 'framework/ui/mui-builder';
import { EDITABLE_LIST_CUSTOM, EDITABLE_LIST_FIELD } from 'framework/list';
import { FormattedTextField, TextFieldWithPrefix } from 'framework/ui/field';
import { RisksType } from 'domain/shared/newProject';
import RiskField from 'domain/projects/newProject/risks/RiskField';
import RiskOwnerField from 'domain/projects/newProject/risks/RiskOwnerField';
import { LastUpdateField } from 'domain/projects/newProject/risks/fields';
import ControlListSection from '../../shared/ControlListSection';

const RiskSection = ({ title, risks, emptyMessage }: { title: string; risks: RisksType[]; emptyMessage: string }) => (
  <ControlListSection
    title={title}
    items={risks}
    listSource="risks"
    emptyMessage={emptyMessage}
    getTableCells={() =>
      Promise.resolve([
        {
          type: EDITABLE_LIST_CUSTOM,
          isEditor: false,
          component: RiskField,
          componentProps: {
            projectId: 'projectId',
            idSource: 'id',
            aliasSource: 'alias',
            newRiskForm: true,
          },
          gridCellProps: {
            size: 0.5,
            sx: { '.MuiFormControl-root': { mb: 0 }, display: 'flex', justifyContent: 'flex-start' },
          },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'title',
          isEditor: false,
          component: FormattedTextField,
          componentProps: {
            label: '',
            format: (str: string) =>
              str && str.length > 60 ? (
                <Tooltip title={str}>
                  <div>
                    <Typography
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.2,
                        wordBreak: 'break-word',
                      }}
                    >
                      {str}
                    </Typography>
                  </div>
                </Tooltip>
              ) : (
                str
              ),
          },
          gridCellProps: {
            size: 3,
          },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'probability',
          isEditor: false,
          component: TextFieldWithPrefix,
          componentProps: {
            label: '',
            tooltipProps: {
              title: 'Probability',
              children: (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <PriorityIcon fontSize="small" />
                </Box>
              ),
            },
          },
          gridCellProps: {
            size: 1.5,
          },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'severity',
          isEditor: false,
          component: TextFieldWithPrefix,
          componentProps: {
            label: '',
            tooltipProps: {
              title: 'Severity',
              children: (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SeverityIcon fontSize="small" />
                </Box>
              ),
            },
          },
          gridCellProps: {
            size: 1.5,
          },
        },
        {
          type: EDITABLE_LIST_FIELD,
          source: 'riskOwner',
          isEditor: false,
          component: RiskOwnerField,
          componentProps: {
            label: '',
            format: (value: string) => value || '-',
          },
          gridCellProps: {
            size: 2,
          },
        },
        {
          type: EDITABLE_LIST_CUSTOM,
          source: 'updatedAt',
          isEditor: false,
          component: LastUpdateField,
          componentProps: {
            createSource: 'createdAt',
            updateSource: 'updatedAt',
          },
          gridCellProps: {
            size: 1.5,
            alignItems: 'center',
          },
        },
      ])
    }
  />
);

export default RiskSection;
